import { EcommStore } from '../internal/stores/EcommStore';
import { events, on } from '@estee/elc-service-bus';

export class ServiceBusController {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private ecommStore: EcommStore) {}

    @on(events.CHANGE_LOCATION)
    public changeLocation = async (payload: { redirectUrl: string }) => {
        this.ecommStore.changeLocation(payload.redirectUrl);
    };
}
